import React from 'react';
import { IProduct } from '@kizi/comparator-core';
import { Div, Image, P, Span } from '@kizi/core-components';
import { DocumentUrl, sendCustomEvent } from '../../../components';
import { ComparisonSubmitButton } from '../../../components/comparison/ComparisonSubmitButton';
import { onClick } from '../../product';
import { IconV2 as Icon } from '@kizi/shared-components';
// import { DocumentUrl } from '@kizi/comparator-components';

const getInstantAcceptanceIcon = (level) => {
  const icons = {
    'GEEN_SELECTIE_OF_WACHTTIJD': 'green-check',
    'WACHTTIJD': 'green-check',
    'BEOORDELING': 'small-cancel',
    'BEOORDELING_GEEN_WACHTTIJD': 'small-cancel',
    'BEOORDELING_EN_WACHTTIJD': 'small-cancel',
  };

  return icons[level] || 'questionmark';
};

const isWachttijdHidden = (level) => {
  const isComponentHidden =
    level === 'GEEN_SELECTIE_OF_WACHTTIJD' ||
    level === 'BEOORDELING' ||
    level === 'BEOORDELING_GEEN_WACHTTIJD';

  if (isComponentHidden) {
    return true;
  }

  return false;
};

const onApplyClick = async (service, data: IProduct) => {
  const interpreter = service.state.context.steps[3];
  if (data.affiliateUrl) {
    sendCustomEvent('affiliate-apply', {
      selectedProduct: data,
    });
    const overviewIndex = service._state.context.steps.findIndex(
      (step) => step.id === 'productComparison',
    );
    service.send([
      {
        type: 'GOTO',
        index: overviewIndex,
      },
    ]);

    const url = new URL(window.location.href);
    if (url.searchParams.has('affiliateUrl')) {
      return;
    }
    url.searchParams.set('step', 'overview');

    window.open(`${url.toString()}&affiliateUrl`);
  } else {
    onClick(interpreter, service, data, 4);
  }
};

export const getProductComparisonOverview = (data, _labels) => {
  const {
    image,
    testScore,
    purchasableProduct,
    name,
    rivm,
    coverageBasicHealths,
    coverageAdditionalHealths,
    coverageDentistHealths,
    strictestLevelNewInsured,
  } = data;

  return [
    {
      content: (
        <Div display="flex" flexDirection="column" alignItems="center">
          <Div display="flex" variant="productLogoWrapper" mb={[2, null, 5]}>
            {image ? (
              <Image
                alt={`logo-${name}`}
                height="100%"
                src={image}
                width="100%"
              />
            ) : (
              <Div height={40} />
            )}
          </Div>
        </Div>
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: <Div>{rivm}</Div>,
      isVisible: true,
      toggleable: false,
    },
    {
      content: (
        <Div display="flex" flexDirection="column">
          <Div
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            <Div>Basisverzekering</Div>
            <P variant="baseBodyImportant">
              €{' '}
              {coverageBasicHealths.totalInstallmentAmount
                .toFixed(2)
                .replace('.', ',')}
            </P>
          </Div>
          {coverageAdditionalHealths.length > 0 && (
            <Div
              mt={3}
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
            >
              <Div>Aanvullend</Div>
              <P variant="baseBodyImportant">
                €{' '}
                {coverageAdditionalHealths[0].totalInstallmentAmount
                  .toFixed(2)
                  .replace('.', ',')}
              </P>
            </Div>
          )}
          {coverageDentistHealths.length > 0 && (
            <Div
              mt={3}
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
            >
              <Div>Tandarts</Div>
              <P variant="baseBodyImportant">
                €{' '}
                {coverageDentistHealths[0].totalInstallmentAmount
                  .toFixed(2)
                  .replace('.', ',')}
              </P>
            </Div>
          )}
        </Div>
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: (
        <Div display="flex">
          <Icon my="auto" height={28} name={'favicon'} width={28} />
          <Div display="flex" alignItems="end">
            <Span>Testoordeel:&nbsp;</Span>
            <Span fontWeight={600}>
              {testScore?.toFixed(1).replace('.', ',')}
            </Span>
          </Div>
        </Div>
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: (
        <Div display="flex" flexDirection="column">
          <Div display="flex" alignItems="center">
            <Div>
              <Icon my="auto" height={28} name={'green-check'} width={28} />
            </Div>
            <Div>Ziekenhuiskeuze:</Div>&nbsp;
            <Div fontWeight={600}>
              {coverageBasicHealths.freeChoiceOfCaregiver}
            </Div>
          </Div>

          <Div mt={3} display="flex">
            <Icon
              my="auto"
              height={28}
              width={28}
              name={getInstantAcceptanceIcon(strictestLevelNewInsured)}
            />
            <Div display="flex" alignItems="center">
              Directe acceptatie
            </Div>
          </Div>

          {!isWachttijdHidden(strictestLevelNewInsured) && (
            <Div mt={3} display="flex">
              <Div>
                <Icon my="auto" height={28} name={'small-alert'} width={28} />
              </Div>
              <Div display="flex" alignItems="center">
                <Span>{'Wachttijd:'}&nbsp;</Span>
                <Span fontWeight={600}>{'1 jaar'}</Span>
              </Div>
            </Div>
          )}
        </Div>
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: data.purchasableProduct ? (
        <Div display="flex" justifyContent="center">
          <ComparisonSubmitButton
            data={data}
            fieldName="overview.selectedProduct"
            nextIndex={4}
            onSubmitFn={onApplyClick}
            isProductEnabled={purchasableProduct}
          />
        </Div>
      ) : (
        <Div display="flex" justifyContent="center">
          <Div>Geen samenwerking met verzekeraar</Div>
        </Div>
      ),
      isVisible: true,
      toggleable: false,
    },
  ];
};

export const getProductComparisonCharacteristics = (data, _labels) => {
  const {
    companyGroupName,
    coverageBasicHealths,
    coverageAdditionalHealths,
    coverageDentistHealths,
    rivm,
    strictestLevelNewInsured,
    deliveryMethods,
    declarationMethods,
  } = data;

  return [
    {
      content: <Div>{companyGroupName}</Div>,
      isVisible: true,
      toggleable: false,
    },
    {
      content: <Div>{coverageBasicHealths.productDescription}</Div>,
      isVisible: true,
      toggleable: false,
    },
    {
      content: (
        <Div>
          {coverageAdditionalHealths.length > 0 && (
            <Div>
              {coverageAdditionalHealths.map((elem) => {
                return (
                  <li key={elem.productCode}>{elem.productDescription}</li>
                );
              })}
            </Div>
          )}
          {coverageDentistHealths.length > 0 && (
            <Div>
              {coverageDentistHealths.map((elem) => {
                return (
                  <li key={elem.productCode}>{elem.productDescription}</li>
                );
              })}
            </Div>
          )}
        </Div>
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: <Div>{rivm}</Div>,
      isVisible: true,
      toggleable: false,
    },
    {
      content: <Div>{coverageBasicHealths.freeChoiceOfCaregiver}</Div>,
      isVisible: true,
      toggleable: false,
    },
    {
      content: (
        <Div>{`€ ${coverageBasicHealths.deductibleAmount
          ?.toFixed(2)
          .replace('.', ',')}`}</Div>
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: (
        <Div display="flex">
          <Div>
            <Icon
              my="auto"
              height={28}
              name={getInstantAcceptanceIcon(strictestLevelNewInsured)}
              width={28}
            />
          </Div>
          <Div display="flex" alignItems="center">
            <P variant="footnoteRegular">
              {getInstantAcceptanceIcon(strictestLevelNewInsured) ===
              'green-check'
                ? 'Ja'
                : 'Nee'}
            </P>
          </Div>
        </Div>
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: (
        <Div display="flex" alignItems="center">
          <Icon name="small-alert" width={28} height={28} />
          <P variant="footnoteRegular"> 1 jaar</P>
        </Div>
      ),
      isVisible: !isWachttijdHidden(strictestLevelNewInsured),
      toggleable: false,
    },
    {
      content: (
        <Div>
          {deliveryMethods
            ? deliveryMethods.map((elem) => {
                if (elem.isSupported) {
                  return (
                    <li>
                      {elem.method[0] + elem.method.slice(1).toLowerCase()}
                    </li>
                  );
                }
                return null;
              })
            : null}
        </Div>
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: (
        <Div>
          {declarationMethods
            ? declarationMethods.map((elem) => {
                if (elem.isAllowed) {
                  return <li>{elem.method}</li>;
                }
                return null;
              })
            : null}
        </Div>
      ),
      isVisible: true,
      toggleable: false,
    },
  ];
};

const getProductComparisonDocuments = (data) => {
  return [
    {
      content: (
        <Div>
          {data.documents.map((elem) => {
            return (
              <DocumentUrl
                key={elem.urlAttachment}
                href={elem.urlAttachment}
                label={elem.attachmentDescription}
                mb={3}
                pb={'1rem'}
                borderBottom="1px solid #D8D8D8"
              />
            );
          })}
        </Div>
      ),
      isVisible: true,
      toggleable: false,
    },
  ];
};

const getProductComparisonAdditionalCoverages = (data) => {
  const { policyDetails } = data?.policyCoverageDetails;

  // Rows length coming from CoverageComparisonWrapper from additionalCoverages. It works just a placeholder for how many rows
  return policyDetails.map((elem) => {
    return {
      content: (
        <Div>
          <P>{elem.coverageTitle}</P>
          <P>{elem.contractSummary}</P>
        </Div>
      ),
      isVisible: true,
      toggleable: false,
    };
  });
};

const GetProductComparisonExtraAdditionalCoverages = (data) => {
  const allPolicies = data?.policyCoverageDetails?.allPolicies;
  if (allPolicies) {
    return allPolicies.map((elem) => ({
      label: elem?.title ?? '-',
      children: elem?.coverages?.map((coverage) => coverage?.contractSummary),
    }));
  } else {
    return [
      {
        content: <P>Bezig met laden...</P>,
        isVisible: true,
        toggleable: false,
        label: '',
        children: [''],
      },
    ];
  }
};

export const cbHealthHelpers = {
  overview: getProductComparisonOverview,
  characteristics: getProductComparisonCharacteristics,
  documents: getProductComparisonDocuments,
  additionalCoverages: getProductComparisonAdditionalCoverages,
  extraAdditionalCoverages: GetProductComparisonExtraAdditionalCoverages,
};
